import { render, staticRenderFns } from "./addIpWhitelist.vue?vue&type=template&id=20121a5c&lang=pug"
import script from "./addIpWhitelist.vue?vue&type=script&lang=js"
export * from "./addIpWhitelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports